import React from "react";
import Navbar from "@/components/Navbar";
import { Card, CardHeader, CardContent } from "@/components/ui/card";
import TeamMembersGrid from "@/components/ispai/TeamMembersGrid";
import DomainElements from "@/components/ispai/DomainElements";
import IspaiHeader from "@/components/ispai/IspaiHeader";
import { Domain } from "@/types/domain";
import KnowledgeNetworkStats from "@/components/shared/KnowledgeNetworkStats";
import ConversationPanel from "@/components/shared/ConversationPanel";
import CommandDemo from "@/components/construction/CommandDemo";
import { useIspaiNetworkStats } from "@/hooks/useIspaiNetworkStats";
import { Loader2 } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
const teamMembers = [{
  image: "/lovable-uploads/39305cb5-47ab-4254-81cd-6765d6c7cad4.png",
  alt: "GTM Advisor"
}, {
  image: "/lovable-uploads/a9e5eb36-05b8-4ba5-b8f6-917e1d77c481.png",
  alt: "Innovation Logistics"
}, {
  image: "/lovable-uploads/8c9f443c-2fbc-4763-8a1a-69d3f4076e4d.png",
  alt: "Brand Marketing Expert"
}, {
  image: "/lovable-uploads/487775c8-5ff0-4b5f-bc47-b449eb15f984.png",
  alt: "Finance Expert"
}, {
  image: "/lovable-uploads/e98049ee-495a-4700-9f03-d39e22e3a116.png",
  alt: "Strategic Sourcing"
}, {
  image: "/lovable-uploads/084aa47a-c241-4e95-a90d-8bf41d5c5a0a.png",
  alt: "Security Expert"
}, {
  image: "/lovable-uploads/01817a77-50a5-4764-a5be-a08ff84c2c0d.png",
  alt: "Blockchain Expert"
}, {
  image: "/lovable-uploads/645369ee-7ed8-4496-a783-9195e483aded.png",
  alt: "Innovation Expert"
}, {
  image: "/lovable-uploads/fdd951b2-2403-445a-9505-77bbb0050939.png",
  alt: "AI For All"
}, {
  image: "/lovable-uploads/27886eb6-0acd-4b44-96bd-a9103cb86f05.png",
  alt: "Product Design Expert"
}, {
  image: "/lovable-uploads/90811df9-aabf-443e-803c-c0e051fa300b.png",
  alt: "Supply Chain and Law Expert"
}, {
  image: "/lovable-uploads/enrique-barrantes-gibnifty-v2.png",
  alt: "Head of Application Development and Integration"
}, {
  image: "/gibniftys/pete-dumont.png",
  alt: "Pete Dumont"
}, {
  image: "/placeholder.svg",
  alt: "Louie Ehrlich"
}, {
  image: "/placeholder.svg",
  alt: "Ed Barrows"
}];

const IspaiChannel = () => {
  const { data: networkStats, isLoading } = useIspaiNetworkStats();

  // Fetch domains from database
  const { data: domains = [], isLoading: isLoadingDomains } = useQuery({
    queryKey: ['ispai-domains'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('domains')
        .select('id, name, symbol, description, industry_name')
        .eq('channel_id', '28570003-dd67-4842-bc21-784df8caaf94')
        .order('name');
      
      if (error) throw error;
      
      // Transform to match Domain interface
      return (data || []).map(d => ({
        symbol: d.symbol || '',
        name: d.name,
        categories: d.description || '',
        overview: d.description || '',
        roleInIspai: ''
      })) as Domain[];
    }
  });

  return <div className="min-h-screen bg-muted">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-6">
          <ConversationPanel channelName="iSPAI" />
        </div>
        <CommandDemo channelName="iSPAI" />
        <IspaiHeader />
        <TeamMembersGrid members={teamMembers} useProfileAvatars={true} />
        
        <Card className="mb-6">
          <CardHeader>
          </CardHeader>
          <CardContent>
            <div className="mb-8">
              <h2 className="text-xl font-semibold mb-4">Dashboard</h2>
              {isLoading ? (
                <div className="flex items-center justify-center p-12">
                  <Loader2 className="h-8 w-8 animate-spin text-primary" />
                </div>
              ) : networkStats ? (
                <KnowledgeNetworkStats {...networkStats} channelName="ispai" />
              ) : (
                <div className="text-center p-12 text-muted-foreground">
                  No data available
                </div>
              )}
            </div>

            <div onClick={() => window.open('https://img1.wsimg.com/blobby/go/70e764c8-c764-4e83-ada3-5ccb3a393f3d/downloads/957872b3-238f-4812-8995-e790421fa472/iSPAI%20Industry_iSPAI.pdf?ver=1737391654284', '_blank')} className="bg-white border-2 border-black p-4 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors mb-6">
              <h3 className="text-xl font-semibold text-center">iSPAI Industry Template</h3>
            </div>

            <h2 className="text-xl font-semibold mb-4">Web3 & AI Agent Domain Elements</h2>
            {isLoadingDomains ? (
              <div className="flex items-center justify-center p-12">
                <Loader2 className="h-8 w-8 animate-spin text-primary" />
              </div>
            ) : (
              <DomainElements domains={domains} channelId="28570003-dd67-4842-bc21-784df8caaf94" />
            )}
          </CardContent>
        </Card>
      </main>
    </div>;
};
export default IspaiChannel;
